import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { withRouter } from "react-router";
import LoaderPopup from "../Common/CommonComponents/LoadingSpinner/loadingSpinner";
import AuthHoc from '../Common/CommonHoc/AuthHoc';
import PreferenceCenterHelper from "./preferenceCenterHelper";
import DialogBox from "../Common/CommonComponents/sceDialogBox";
import CpcPopup from "./common/CpcPopup";
import { getLocalizedStrings } from './centralizedLocalizedString';

export default class CentralizedContainer extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings("PaperlessBilling");
    this.state = {
      cpcData: {},bpErrorCntr:0,bpErrorMsgSwitch:true,preferenceContent: undefined,errorCard: undefined,loaderDialogBox: true,bpMatch:false,
      webUser: false,isGuestUser:false,errorMessage: "",isGetContactError: false,staticContent: "",marketRefresh:"",marketregrefresh:"",profileData:{},previousreq:"",
      showPopUp: false,
    };
    this.profileData={};
  }
  componentWillMount() {
    if(app.appService.isCpcGuestUser()) app.pubSubService.publish('startIdleSessionExpiring', 'Start Idle Session is going to expire');
    
    if (app.appService.isAuthenticated()|| app.appService.isCpcGuestUser()) {
     let isValidBPNumber = !_.isEmpty(
        app.appService.getUserInfo().profileData.accountData
      );
      this.profileData = app.appService.getUserInfo().profileData.profile;
      let userGroup = app.appService.getPrioritisedUserGrp();
      let isGuestUser = userGroup === app.appUtil.getAppConstants().USER_GROUPS.GUESTUSERS;
      this.setState({profileData: this.profileData, isGuestUser: isGuestUser}, ()=>{
        (userGroup === app.appUtil.getAppConstants().USER_GROUPS.MYACCOUNT || isGuestUser) &&
        isValidBPNumber
          ? this.getMyAccountDetails()
          : this.getWebUserDetails();
      });
    }    
  }

  componentWillUnmount() {
    app.appUtil.unsetFontAwesomeNesting();
    if(app.appService.isCpcGuestUser()) app.pubSubService.publish('stopIdleSessionExpiring', 'Stop Idle Session');
  }

  getMyAccountDetails = (offset = 0, coOffset = 0) => {
    let userType = this.state.isGuestUser ? "GUEST" : "MA";
    app.centralizedService.getCpcPreference(app.appService.getUserInfo().profileData.accountData.mainBusinessPartner.businessPartnerNumber, this.profileData.eixSCEUID, userType,offset,coOffset)
      .then((response) => {

        let errorPrograms = new Map(response.errorResponseVo.map(o => [o.programDetails, o]));
        let programError = errorPrograms.get("CPC_PROGRAMS_LANGUAGE");
        if ((response.errorCode !== undefined && response.errorCode !== "")||(!_.isEmpty(programError))) {
          this.setState({cpcData: "",webUser: false,loaderDialogBox: false,errorCard: true,preferenceContent: false,
          });
        } else {
          let acctType = response.accountType;
          let contractAccountResults=[];
          let acctCategory="Residential";
          contractAccountResults=response.contractAccountResults;
          contractAccountResults.map((category)=>{
                if(category.bpCategory==='2'){
                  acctCategory='Business';
 
                }
               
              });
          if(app.appService.isAuthenticated() && app.appService.getPrioritisedUserGrp() === app.appUtil.getAppConstants().USER_GROUPS.MYACCOUNT && response.contractAccountCount === 1 || response.contractAccountCount === 0){
            let userInfo = app.appService.getUserInfo();
            const accountType = userInfo.accountType;
            app.analyticsService.addPageLevelData('accountType',accountType,'');}
              let showPopUpFlag = this.profileData.eixSCEOBStatusIndicator === app.appUtil.getAppConstants().EPFLAG;            
          this.setState({
            cpcData: response,loaderDialogBox: false,
            errorCard: false,preferenceContent: true,webUser: false,
            showPopUp: showPopUpFlag,
          });
          if(showPopUpFlag){            
            app.centralizedService.cpcRedirect().then((response) => {  });
            let profileData = app.appService.getUserInfo().profileData;
            profileData.profile.eixSCEOBStatusIndicator = app.appService.appConstants.BLANK;
            app.appService.setProfileData(profileData);
          }}
      });};
  getWebUserDetails = (offset = 0, coOffset = 0) => {
    let errCntr = this.state.bpErrorCntr;
    let errSwitch = (errCntr > 0 ? false:true);
    app.centralizedService.getWebUserDetails(this.profileData).then((response) => {
      if (response.countOfBusinessParter === 1) {
        app.appService.setLocalStorage("bpDetails",response.businessPartnerList);
        app.centralizedService.getCpcPreference(response.businessPartnerList[0].businessPartnerNumber,"","Web",offset,coOffset)
          .then((response) => {
            if ((!_.isEmpty(response.errorCode))
            ) {
              this.setState({loaderDialogBox: false,errorCard: true,bpErrorMsgSwitch: errSwitch,bpErrorCntr:this.state.bpErrorCntr + 1,preferenceContent: false});
            } else {
              let acctType = response.accountType;
              let contractAccountResults=[];
              let acctCategory="Residential";
              contractAccountResults=response.contractAccountResults;
              contractAccountResults.map((category)=>{
                    if(category.bpCategory==='2'){
                      acctCategory='Business';     
                    }                   
                  });
                  app.analyticsService.addPageLevelData('accountType',acctCategory+' | '+acctType, '');
                  window.aUtils.sendAAEvent('accountType',acctCategory+' | '+acctType);
              this.setState({cpcData: response,webUser: true,loaderDialogBox: false,errorCard: false,bpErrorCntr:0,preferenceContent: true});
            }
          });
      } else{
        this.setState({bpMatch: true,loaderDialogBox: false,errorCard: true,bpErrorCntr:this.state.bpErrorCntr + 1,bpErrorMsgSwitch: errSwitch,preferenceContent: false});
      }
    });};
  handlerefreshtxt=()=>{
    let currState = { ...this.state };
    app.centralizedService.modifyPreferencesrefresh(this.state.previousreq,this.state.cpcData).then((response) => {
      if(response.refreshError) {
        currState.marketregrefresh=true;
      }else {
        currState.marketregrefresh=false;
        if (response.category!=="") {
          currState.cpcData.marketingPref=response.marketingPref;
        }
      }
      this.setState(currState,()=>{});
    });
  }
  
  handleMarketingPref = (enrollStatus) => {
    this.setState({...this.state, loaderDialogBox: true});
    let currState = { ...this.state };
    app.centralizedService.modifyPreferences(this.state.cpcData,enrollStatus).then((response) => {
      currState.previousreq=response.previousreq;
      currState.loaderDialogBox = false;
      if(response.refreshError) {
        currState.marketregrefresh=true;
        currState.cpcData.marketingPref=response.marketingPref;
        app.appService.setSessionstorage('marketingPref',response.marketingPref);
      }else {
        currState.marketregrefresh=false;
        if (response.category!=="") {
          currState.cpcData.marketingPref=response.marketingPref;
          app.appService.setSessionstorage('marketingPref',response.marketingPref);
        }
      }
      this.setState(currState,()=>{});
    });
  }

  handleRefreshMkpr = ()=>{
    let currState={...this.state};
    app.centralizedService.getOnloadRefresh(this.state.cpcData.bpNumber).then((response) => {
      currState.cpcData.marketingPref=response.marketingPref;
      currState.marketRefresh=true;
      app.appService.setSessionstorage('marketingPref',response.marketingPref);
      this.setState(currState,()=>{});
    },(error)=>{
      currState.marketRefresh=false;
      this.setState(currState,()=>{});
    });
}
  retrieveInputData = (data) => {
    let inputDataState =  this.state.profileData ;
    inputDataState[data.id] = data["value"];
    inputDataState.isError = data["isError"];
    this.setState({profileData:inputDataState});
  };
  disp = () => {
    this.getWebUserDetails();};
  handleRefreshAccPref(conAccNum,conNum,premiseNumber,bpNumber, bpContactNumber){
    return app.centralizedService.getPreferenceRefresh(conAccNum,conNum,premiseNumber,bpNumber, bpContactNumber).then(
      (response) => {
        if (response.errorMessage !== "") {
          return Promise.resolve(response);
        }else{return null;}
    },(error) => {return Promise.resolve(error);});
 
  }
  onDialogCloseHandler = () => {
    this.setState({...this.state, showPopUp: false});
  }
  render() {
    return (
      <div>
        {this.state.loaderDialogBox ? <LoaderPopup /> : null}
        <DialogBox width='600px' displayDialog={this.state.showPopUp}
           onDialogCloseHandler={this.onDialogCloseHandler} tncType >
            <CpcPopup onDialogCloseHandler={this.onDialogCloseHandler} msg={this.strings.popupMsg} />
          </DialogBox>
        <PreferenceCenterHelper retrieveInputData={this.retrieveInputData} bpErrorMsgSwitch={this.state.bpErrorMsgSwitch} disp={this.disp} bpMatch={this.state.bpMatch} bpErrorCntr={this.state.bpErrorCntr} errorCard={this.state.errorCard} 
          preferenceContent={this.state.preferenceContent} marketregrefresh={this.state.marketregrefresh} marketRefresh={this.state.marketRefresh} cpcData={this.state.cpcData} handleRefreshAccPref={this.handleRefreshAccPref.bind(this)} 
          webUser={this.state.webUser} profileData={this.state.profileData} handleMarketingPref={this.handleMarketingPref.bind(this)} handleRefreshMkpr={this.handleRefreshMkpr.bind(this)}  handlerefreshtxt={this.handlerefreshtxt.bind(this)} getWebUserDetails={this.getWebUserDetails} getMyAccountDetails={this.getMyAccountDetails} guestUser={this.state.isGuestUser} noBanner={this.props.noBanner} billingRateType={this.props.billingRateType} />
      </div>
    );
  }
}

const CentralizedContainer1 = AuthHoc(withRouter(CentralizedContainer), true);
(function () {
  AppModule.init(fetchLibs);
  app.appUtil.setFontAwesomeNesting();

  /***commented this as page not found error was obtained when user trying to signup for 
   * paperless billing from welcome email***/
  // if (!app.appService.isAuthenticated()){
  //   app.appService.customPostLoginNavigation(app.appUtil.getAppRoutes().CPC.CPC_LANDINGPAGE);
  // }
})();

function fetchLibs() {
  app.appUtil.appDependencyService.loadDependencyLibs(renderComponent, 23);
}

function renderComponent() {
  ReactDOM.render(
    <Router>
      <CentralizedContainer1 />
    </Router>,
    document.getElementById("react-centralized-preference")
  );
}
